import { render, staticRenderFns } from "./TeaserServiceElement.vue?vue&type=template&id=456ede20"
import script from "./TeaserServiceElement.vue?vue&type=script&lang=ts"
export * from "./TeaserServiceElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports